export const ACCESS_LOGS_STATUSES = {
  SUCCESS: 'SUCCESS',
}
